
import { Component, Vue } from "vue-property-decorator";
import GuncellemelerDialog from "@/components/infos/GuncellemelerDialog.vue";
import { UpdateItem, duyurulariNormalizeEt, yeniSayisi } from "@/components/infos/guncellemeler";

const API_LIST = "https://zirve-bilgisayar.com/ajax/duyurular";
const YENILEME_ARALIGI = 60 * 60 * 1000; // 1 saat
const ISTEK_ZAMAN_ASIMI = 15 * 1000;

@Component({
  components: { GuncellemelerDialog }
})
export default class GuncellemelerInfo extends Vue {
  dialog = false;
  items: UpdateItem[] = [];
  loading = false;
  hata = false;
  simdi = new Date();
  yenilemeId: number | null = null;

  /** Badge: bu hafta (Pazartesi'den bugüne) gelen farklı duyuru sayısı */
  get yeniAdet(): number {
    return yeniSayisi(this.items, this.simdi);
  }

  /** butona basınca: pencere açılır, liste arka planda tazelenir */
  openDialog() {
    this.dialog = true;
    this.fetchUpdates();
  }

  /** GENEL YÜKLEYİCİ */
  async fetchUpdates() {
    this.simdi = new Date();
    if (this.loading) return;
    this.loading = true;
    // Yanıt vermeyen istek loading'i kilitleyip sonraki yenilemeleri engellemesin
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), ISTEK_ZAMAN_ASIMI);
    try {
      // $http yerine düz fetch: interceptor dış siteye token/TCKN başlıklarını eklemesin,
      // arka plan yenilemesinde bekleme imleci ve hata toast'u çıkmasın
      const response = await fetch(API_LIST, { credentials: "omit", signal: controller.signal });
      if (!response.ok) throw new Error("HTTP " + response.status);
      this.items = duyurulariNormalizeEt(await response.json());
      this.hata = false;
    } catch (e) {
      // Liste doluysa eskisi korunur; boşsa dialog hata mesajı gösterir
      console.warn("Güncellemeler getirilemedi:", e);
      this.hata = true;
    } finally {
      window.clearTimeout(timer);
      this.loading = false;
    }
  }

  /** Saatlik yenileme: yeni duyurular ve hafta dönümü sayfa yenilenmeden badge'e yansır */
  mounted() {
    this.fetchUpdates();
    this.yenilemeId = window.setInterval(() => this.fetchUpdates(), YENILEME_ARALIGI);
  }

  beforeDestroy() {
    if (this.yenilemeId !== null) {
      window.clearInterval(this.yenilemeId);
      this.yenilemeId = null;
    }
  }
}
